import AnalyticsEngineBase from "./../analyticsenginebase";
import { injectScript } from "./../../utilities/DOMUtils";
import {
  PERCENTAGE_IN_VIEW_COMPUTED,
  VIEW_ARTICLE_ALB,
  CLOSED_ALB,
  PAN_PAGE,
  ZOOM_PAGE_IN_READER,
  ZOOM_PAGE_IN_READER_ON_DESKTOP,
  ZOOM_PAGE_OUT_READER,
  ZOOM_PAGE_OUT_READER_ON_DESKTOP,
  OPENED_GALLERY_ALB,
  CLOSED_GALLERY_ALB,
  RESIZED_READER,
} from "./../analyticsevents";

/**
 * ER SDK analytics engine
 */
export default class AnalyticsEngineER extends AnalyticsEngineBase {
  constructor(analyticsManager, options = {}) {
    super(analyticsManager, options);
    if (process.env.ENV !== "production") {
      injectScript(
        "https://sdk.engagereaders.net/uat/twipe-er-sdk.min.js",
        this._onload.bind(this)
      );
    } else {
      injectScript(
        "https://sdk.engagereaders.net/production/twipe-er-sdk.min.js",
        this._onload.bind(this)
      );
    }

    this._subscribeToEvents();
  }

  //////////////

  _onload() {
    TwipeER.initialize({ tag: this._options.erTag });
  }

  _subscribeToEvents() {
    $(window).on("beforeunload", () => {
      AnalyticsEngineER._sendEvent("closePublication");
    });
    this._analyticsManagerBase.on(PERCENTAGE_IN_VIEW_COMPUTED, (data) => {
      AnalyticsEngineER._sendEvent(data, this._analyticsManagerBase.cmpManager);
    });
    this._analyticsManagerBase.on(VIEW_ARTICLE_ALB, (data) => {
      AnalyticsEngineER._sendEvent(data, this._analyticsManagerBase.cmpManager);
    });
    this._analyticsManagerBase.on(CLOSED_ALB, (data) => {
      AnalyticsEngineER._sendEvent(data, this._analyticsManagerBase.cmpManager);
    });
    this._analyticsManagerBase.on(PAN_PAGE, (data) => {
      AnalyticsEngineER._sendEvent(data, this._analyticsManagerBase.cmpManager);
    });
    this._analyticsManagerBase.on(ZOOM_PAGE_IN_READER, (data) => {
      AnalyticsEngineER._sendEvent(data, this._analyticsManagerBase.cmpManager);
    });
    this._analyticsManagerBase.on(ZOOM_PAGE_IN_READER_ON_DESKTOP, (data) => {
      AnalyticsEngineER._sendEvent(data, this._analyticsManagerBase.cmpManager);
    });
    this._analyticsManagerBase.on(ZOOM_PAGE_OUT_READER, (data) => {
      AnalyticsEngineER._sendEvent(data, this._analyticsManagerBase.cmpManager);
    });
    this._analyticsManagerBase.on(ZOOM_PAGE_OUT_READER_ON_DESKTOP, (data) => {
      AnalyticsEngineER._sendEvent(data, this._analyticsManagerBase.cmpManager);
    });
    this._analyticsManagerBase.on(OPENED_GALLERY_ALB, (data) => {
      AnalyticsEngineER._sendEvent(data, this._analyticsManagerBase.cmpManager);
    });
    this._analyticsManagerBase.on(CLOSED_GALLERY_ALB, (data) => {
      AnalyticsEngineER._sendEvent(data, this._analyticsManagerBase.cmpManager);
    });
    this._analyticsManagerBase.on(RESIZED_READER, (data) => {
      AnalyticsEngineER._sendEvent(data, this._analyticsManagerBase.cmpManager);
    });
  }

  static _sendEvent(data, cmpManager) {
    let isTrackingEnable = true;

    if (cmpManager) {
      isTrackingEnable = cmpManager.isERTrackingEnabled();
    }
    // remove useless keys
    const eventDataCopy = JSON.parse(JSON.stringify(data.eventData));
    delete eventDataCopy.bundle.downloadToken;
    const screenInView = data.nextgenEvent ? "nextgenReader" : "replicaReader";
    if (isTrackingEnable) {
      TwipeER.track(
        "elementInViewChanged",
        { ...eventDataCopy },
        data.eventOrigin,
        screenInView,
        { ...data.user },
        { ...data.deviceContext }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/analytics/engines/analyticsEngineER.js